export default {
  namespaced: true,
  state: {
    data: '首页'
  },
  mutations: {
  },
  actions: {
  }
}



// WEBPACK FOOTER //
// ./src/views/home/store/index.js